import React, { useState, useEffect } from "react";
import "./period-calculator-css/period-calculator.css";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import TrackMyPeriod from "./track-my-period";
import OtherReminders from "./other-reminders";
import configData from "../../temp/config";
import { withTranslation } from "react-i18next";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
import { isMobile } from "react-device-detect";

const PeriodFeatures = (props) => {
  let domain = configData.sitecoreApiHost;
  const [componentData, setComponentData] = useState(componentData);

  const [trackMyPeriod, setTrackMyPeriod] = useState(
    props.fields.features[3].fields
  );
  const [predictPhase, setPredictPhase] = useState(
    props.fields.features[0].fields
  );
  const [otherReminders, setOtherReminders] = useState(
    props.fields.features[1].fields
  );
  const [setReminders, setRemindersFunction] = useState(
    props.fields.features[2].fields
  );
  const { t } = props;

  const [enableTrackMyPeriodBtn, setEnableTrackMyPeriodBtn] = useState(true);
  const [startOverReminer, setstartOverReminder] = useState(false);
  const [isTrackNowClick, setisTrackNowClick] = useState(false);
  const [hideThirdDivMobile, sethideThirdDivMobile] = useState(false);
  const [periodDurationDefaults, setPeriodDurationDefaults] = useState({
    averagePeriodDurationDefault: !isNaN(
      Number(t("PeriodCalculator_PeriodDurationDefaultValue"))
    )
      ? Number(t("PeriodCalculator_PeriodDurationDefaultValue"))
      : 4,
    minimumPeriodDuration: !isNaN(
      Number(t("PeriodCalculator_PeriodDurationMinValue"))
    )
      ? Number(t("PeriodCalculator_PeriodDurationMinValue"))
      : 1,
    maximumPeriodDuration: !isNaN(
      Number(t("PeriodCalculator_PeriodDurationMaxValue"))
    )
      ? Number(t("PeriodCalculator_PeriodDurationMaxValue"))
      : 10,
  });

  const [daysBetweenPeriods, setDaysBetweenPeriods] = useState({
    default: !isNaN(Number(t("PeriodCalculator_CycleLengthDefaultValue")))
      ? Number(t("PeriodCalculator_CycleLengthDefaultValue"))
      : 28,
    minimumValue: !isNaN(Number(t("PeriodCalculator_CycleLengthMinValue")))
      ? Number(t("PeriodCalculator_CycleLengthMinValue"))
      : 21,
    maximumValue: !isNaN(Number(t("PeriodCalculator_CycleLengthMaxValue")))
      ? Number(t("PeriodCalculator_CycleLengthMaxValue"))
      : 38,
  });

  const [periodDuration, setPeriodDuration] = useState("NA");

  useEffect(() => {
    if (props != null && props.fields != null) {
      let componentData = props.fields;
      setComponentData(componentData);
    }
  }, []);

  const trackMyPeriodClick = () => {
    setEnableTrackMyPeriodBtn((enabled) => !enabled);
  };

  return (
    <>
      <div className="container shadow period-cal-padding ">
        <div className={!isMobile ? "second-div" : "d-none"}>
          <div className="sharelinks">
            <Placeholder
              name="social-share"
              rendering={props.rendering}
              itemid={props.itemid}
            />
          </div>
          <br />
          <br />
          <div className="col-md-12 mt-3">
            <p
              className={
                !isMobile ? "calc-description" : "calc-description-mobile"
              }
            >
              <RichText field={props.fields.description} />
            </p>
          </div>
        </div>

        <div
          className={
            !isMobile
              ? "third-div"
              : isMobile && !hideThirdDivMobile
              ? "third-div-mobile"
              : "d-none"
          }
        >
          <button
            disabled={enableTrackMyPeriodBtn}
            className={
              enableTrackMyPeriodBtn
                ? "tablinks shadow"
                : "tablinks bottom-shade"
            }
            onClick={trackMyPeriodClick}
          >
            <span className={!isMobile ? "circle" : "d-none"}>
              <img
                src={domain + trackMyPeriod.image.value.src}
                alt="calendar_image"
              />
            </span>
            <span className="align-tab-heading">
              {trackMyPeriod.title.value}
            </span>
          </button>

          <button
            disabled={!enableTrackMyPeriodBtn}
            className={
              !enableTrackMyPeriodBtn
                ? "tablinks shadow"
                : "tablinks bottom-shade"
            }
            onClick={trackMyPeriodClick}
          >
            <span className={!isMobile ? "circle" : "d-none"}>
              <img
                src={domain + otherReminders.image.value.src}
                alt="bell_image"
              />
            </span>
            <span className="align-tab-heading">
              {otherReminders.title.value}
            </span>
          </button>
        </div>

        <>
          <TrackMyPeriod
            questionSet={trackMyPeriod.QuestionSet}
            submitLabel={trackMyPeriod.submitLabel.value}
            domain={domain}
            periodDurationDefaults={periodDurationDefaults}
            daysBetweenPeriodsDefaults={daysBetweenPeriods}
            predictPhase={predictPhase}
            trackMyPeriodKey={trackMyPeriod.key.value}
            iconList={props.fields["Icon List"]}
            hidethirddiv={sethideThirdDivMobile}
            startover={setEnableTrackMyPeriodBtn}
            setReminders={setReminders.reminders}
            setPeriodDuration={setPeriodDuration}
            dictionary={t}
            isTrackNowClick={setisTrackNowClick}
            enabled={enableTrackMyPeriodBtn}
          />
        </>
        {(!enableTrackMyPeriodBtn || startOverReminer) &&
          otherReminders != null &&
          otherReminders.reminders != null &&
          otherReminders.reminders.map((reminderData, index) => {
            if (
              reminderData != null &&
              reminderData.fields != null &&
              reminderData.fields.ReminderQuestions != null
            ) {
              return (
                <div
                  id={reminderData.fields.key.value}
                  className={
                    !enableTrackMyPeriodBtn || startOverReminer
                      ? isMobile
                        ? "fourth-div-reminders-tab other-reminders-mobile top-padding"
                        : "fourth-div-reminders-tab top-padding"
                      : "d-none"
                  }
                  key={index}
                >
                  <div className="col-sm-4 reminder-heading">
                    {reminderData.fields.title.value}
                  </div>
                  <OtherReminders
                    questionSet={reminderData.fields.ReminderQuestions}
                    reminderKey={reminderData.fields.key.value}
                    submitLabel={otherReminders.SubmitButtonText.value}
                    durationDropDownItems={
                      reminderData.fields.durationDropDownItems
                    }
                    domain={domain}
                    key={index}
                    reminderId={reminderData.id}
                    timeSelectionTooltip={
                      reminderData.fields.timeSelectionTooltip
                    }
                    durationSelectionToolTip={
                      reminderData.fields.durationSelectionToolTip
                    }
                    startDateSelectionTooltip={
                      reminderData.fields.startDateSelectionTooltip
                    }
                    NoofRecurrences={reminderData.fields.NoofRecurrences}
                    startover={setEnableTrackMyPeriodBtn}
                    hidethirddiv={sethideThirdDivMobile}
                    iconList={props.fields["Icon List"]}
                    remindersEnabled={
                      !enableTrackMyPeriodBtn || startOverReminer
                    }
                  />
                </div>
              );
            }
          })}
      </div>
      <div className="footer_div">
        {!isMobile && (
          <div className="col-md-12 seventh-div">
            <p>{props.fields.disclaimerMessage.value}</p>
          </div>
        )}
        {isMobile && (
          <div className="periodcal-disclaimer">
            <p className="periodcal-disclaimer-text">
              {props.fields.disclaimerMessage.value}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default withTranslation()(PeriodFeatures);
